import $api from "../http";
import {
  IGymNotificationGym,
  IUserGymNotificationByGymResponse,
  IUserGymNotificationByUserResponse,
} from "../models/GymNotification";

class GymNotificationServiceClass {
  getGymNotificationGyms(status: string | null, searchValues: string | null) {
    let query = "";
    if (status) query = "status=" + status;
    if (searchValues) query = "&searchValue=" + searchValues;
    return $api.get<IGymNotificationGym[]>(`api/user-gym-listing-notification/gyms?${query}`);
  }

  getGymNotificationsByGymListingId(
    currentPage: number | undefined,
    pageSize: number | undefined,
    gymListingId: string
  ) {
    return $api.get<IUserGymNotificationByGymResponse>(
      `api/user-gym-listing-notification/by-gym-listing/${gymListingId}?currentPage=${currentPage}&pageSize=${pageSize}`
    );
  }

  getGymNotificationsByUserId(
    currentPage: number | undefined,
    pageSize: number | undefined,
    userId: string,
    queryOptions?: { from: string | null; to: string | null }
  ) {
    let queryString = `?currentPage=${currentPage}&pageSize=${pageSize}`;
    if (queryOptions) {
      if (queryOptions.from) {
        queryString += `&fromDate=${queryOptions.from}`;
      }
      if (queryOptions.to) {
        queryString += `&toDate=${queryOptions.to}`;
      }
    }
    return $api.get<IUserGymNotificationByUserResponse>(
      `api/user-gym-listing-notification/by-user/${userId}?${queryString}`
    );
  }

  deleteByGymListingId(gymListingId: string) {
    return $api.delete<{}>(`api/user-gym-listing-notification/by-gym-listing/${gymListingId}`);
  }

  deleteById(id: string) {
    return $api.delete<{}>(`api/user-gym-listing-notification/${id}`);
  }

  updateSentDate(id: string) {
    return $api.put<{}>(`api/user-gym-listing-notification/update-sent-date/${id}`, {});
  }
}

export const GymNotificationService = new GymNotificationServiceClass();
